import React from 'react'

const GetInvolved = () => {
  return (
    <div>GetInvolved</div>
  )
}

export default GetInvolved